<template>
  <div>
    <el-row class="querypanel">
      <el-col :span="12">
        <el-form ref="form"  label-width="120px" label-position="left">
          <el-form-item label="注册日期:">
            <el-date-picker
              v-model="bymemberdate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querymember">查询会员</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-tabs v-model="qdtab">
        <el-tab-pane label="已关注用户" name="ygz">
          <el-table
            stripe
            :data="memberdata"
            ref="multipleTable">
            <el-table-column
              prop="openid"
              width = "200px"
              label="OpenID">
            </el-table-column>
            <el-table-column
              prop="usernick.String"
              width = "200px"
              label="会员昵称">
            </el-table-column>
            <el-table-column
              label="头像">
              <template slot-scope="scope">
                <div v-if="scope.row.userimg.Valid && scope.row.userimg.String !== ''">
                  <img :src="scope.row.userimg.String" class="avatarimg">
                </div>
                <div v-else>
                  {{scope.row.imgurl.String}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="phone.String"
              label="电话号码">
            </el-table-column>
            <el-table-column
              prop="name.String"
              label="姓名">
            </el-table-column>
            <el-table-column
              label="操作"
              width="120px"
            >
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="注销该会员" placement="top-start">
                  <i class="fa fa-trash-o fa-lg opicon curpointer" v-on:click="delmember(scope.$index, memberdata)"></i>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="已完善用户（信息）" name="yws">
        </el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'MemberMana',
  data () {
    return {
      memberdata: [],
      bymemberdate: '',
      qdtab: 'ygz'
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    console.log(that)
  },
  methods: {
    querymember () {
      var qstr = ' openid is not null'
      that.$http({
        url: 'https://api.sqnetsoft.cn/member/gbuw',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.memberdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    delmember (index, data) {
      console.log(data[index])
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id === selectdata.id)
      // 移除该条数据
      data.splice(dataindex, 1)
      var qstr = 'id = ' + selectdata.id
      console.log(qstr)
      that.$http({
        url: 'https://api.sqnetsoft.cn/customer/delcususer',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            console.log(res.data.data)
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/member/MemberMana.vue